import { DatePicker, Form as AntForm } from 'antd';
import styled from 'styled-components';
import { AnySchema } from 'yup';
import { Controller, Control } from 'react-hook-form';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { formHelpers } from '@helpers/formHelpers';
import moment from 'moment';

const { Item: FormItem } = AntForm;
const { RangePicker } = DatePicker;

export const HSMSRangePickerField = styled(RangePicker)`
  &.ant-picker {
    width: 100%;
  }
`;

interface HSMSRangePickerProps {
  label: string;
  name: string;
  format?: string;
  placeholder?: [string, string];
  size?: SizeType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  validationSchema?: AnySchema<Record<string, unknown> | undefined>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any; // If we are setting proper types we need to get the form values. Not possible since we use this in multiple forms
}

export const HSMSRangePicker = ({
  label,
  placeholder,
  name,
  size,
  control,
  format,
  validationSchema,
  errors,
}: HSMSRangePickerProps) => (
  <FormItem
    label={label}
    required={validationSchema && formHelpers.isRequired(validationSchema, name)}
    validateStatus={errors && errors[name] ? 'error' : ''}
    help={errors && errors[name]?.message}
    labelCol={{ span: 24 }}
  >
    <Controller
      as={
        <HSMSRangePickerField
          size={size}
          format={format || 'YYYY-MM-DD'}
          showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
          placeholder={placeholder || ['Start Time', 'End Time']}
        />
      }
      name={name}
      control={control}
    />
  </FormItem>
);
